import { render, staticRenderFns } from "./SimulatorPagination.vue?vue&type=template&id=b4b77726&scoped=true&"
import script from "./SimulatorPagination.vue?vue&type=script&lang=js&"
export * from "./SimulatorPagination.vue?vue&type=script&lang=js&"
import style0 from "./SimulatorPagination.vue?vue&type=style&index=0&id=b4b77726&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b77726",
  null
  
)

export default component.exports